import React from "react";
import { Outlet, useMatches } from "react-router-dom";
import Header from "../Component/Header";

const Header_Layout = () => {
  const matches = useMatches();

  // Check if this route has `handle: { heroHeader: true }`
  const heroHeader = matches.some(
    (m) => m.handle && m.handle.heroHeader
  );

  return (
    <>
      {/* If heroHeader = true, apply transparent mode */}
      <Header hero={heroHeader} />

      {/* Page content */}
      <main>
        <Outlet />
      </main>
    </>
  );
};

export default Header_Layout;
